import React, { useEffect, useState } from "react";
import generalHelper from "../utils/generalHelper.js";

import Inputfield from "../customComponents/Inputfield";
import Button from "../customComponents/Button";
import Checkbox from "../customComponents/Checkbox";
import Popup from "../customComponents/Popup";
import Dropdownlist from "../customComponents/Dropdownlist";
import { ReactSession }  from 'react-client-session';
import styles from "../../assets/stylesheets/sass/Register.module.scss";
import login_styles from '../../assets/stylesheets/Login.module.css';
import parse from 'html-react-parser'
import localforage from "localforage";
import { useNavigate } from "react-router-dom";
// import Qastan from "@qastanfit/logger"
// import Inputfield from './Input';
import FormLoader from './FormLoader';

let password_main = '';
export default function RegisterForm({formLoaded, title, subtitle, onError}){
    const [content_state, setcontent_state] = useState({});
    const navigate = useNavigate();
	useEffect(()=>{
		const fetchData = async () =>{
           const data = await fetch(process.env.REACT_APP_SERVER_LINK+"content");
           let res = await data.json();
           setcontent_state(res);
        }
        fetchData();
	}, [])

    const [error, seterror] = useState();

    // useEffect(()=>{
    //     socket.on("getRegistrationCheck", (data)=>{
    //         if(data){
    //         if(data.errorcode === 0){
    //             setwhite_overlay(true);
    //             setTimeout(function(){
    //                 setwhite_overlay(false);
    //                 setwhite_overlayLR(true);
    //                 setshowRegistrationForm(true)
    //                 formLoaded(true);
    //             }, 300)         
    //         }
    //             else{
    //                 seterrorTitle("Error - " + data.errorcode)
    //                 seterrorMessage("Foutcode [" + data.errorcode + "] " + data.message)
    //                 seterror(data);
    //                 setwhite_overlay(true);
    //                 setTimeout(function(){
    //                     setwhite_overlayLR(true);
    //                     setwhite_overlay(false);
    //                     setshowError(true);
    //                 }, 300)
                    
    //                 onError(true);
    //             }
    //         }
    //         else{
    //             seterrorTitle("Error")
    //             seterrorMessage("Something went wrong...")
    //             seterror(data);

    //             setwhite_overlay(true);
    //             setTimeout(function(){
    //                 setwhite_overlayLR(true);
    //                 setwhite_overlay(false);
    //                 setshowError(true);
    //             }, 300)
                
    //             onError(true);
    //         }
    //     })

    //     socket.on("getRegistrationVerify", (data)=>{
    //         if(data.errorcode === 0){
    //             console.log("Start closing animation");
    //             setwhite_overlay(true);
    //             setwhite_overlayLR(false);
    //             setTimeout(function(){
    //                 handleLogin();
    //             }, 300)
                
    //         }

    //         else{
    //             console.log(data);
    //             seterrorMessage("Foutcode [" + data.errorcode + "] " + data.message)
    //             seterror(data);
    //             setwhite_overlay(true);
    //             setTimeout(function(){
    //                 setwhite_overlayLR(true);
    //                 setwhite_overlay(false);
    //                 setshowError(true);
    //             }, 300)
    //             console.log("Registratie mislukt")
    //         }
    //     })
    // }, [socket])

    const [showError, setshowError] = useState(false);
    const [errorTitle, seterrorTitle] = useState('');
    const [errorMessage, seterrorMessage] = useState('');
    const [showRegistrationForm, setshowRegistrationForm] = useState(false);

    const [registrationcode, setregistrationcode] = useState();
    const [email, setemail] = useState('');
    const [firstname, setfirstname] = useState('');
    const [lastname, setlastname] = useState('');
    const [language, setlanguage] = useState('N');
    const [password, setpassword] = useState('');

    const [pw1, setpw1] = useState('');
    const [pw2, setpw2] = useState('');

    const [error_firstname, seterror_firstname] = useState(false);
    const [error_lastname, seterror_lastname] = useState(false);
    const [error_pw1, seterror_pw1] = useState(false);
    const [error_pw2, seterror_pw2] = useState(false);

    const [white_overlay, setwhite_overlay] = useState(false);
	const [white_overlayLR, setwhite_overlayLR] = useState(false);

    const handleLogin = () => {
        //Gegevens in sessie
        window.sessionStorage.setItem("username", email);
        window.sessionStorage.setItem("password", password_main);
        //Naar / surfen 

        //

        //Authenticate user
        let authenticateData = {
            "username": email,
            "password": password_main
        }
        fetch(process.env.REACT_APP_SERVER_LINK+"login", {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
            },
            body: JSON.stringify(authenticateData)
        }).then(
            res => res.json()
        ).then(
            json => {
                if(json.errorcode === 0){
                    ReactSession.set("language", json.object.language);
                    window.localStorage.setItem("rememberMe", true);
                    window.localStorage.setItem("username", email);
                    window.localStorage.setItem("password", password_main);
                    

                    window.localStorage.setItem("token", json.object.token);

  
                    window.localStorage.setItem("username", email);
                    window.localStorage.setItem("login-"+email, true);
                    
                    
                    window.sessionStorage.setItem("user_data", JSON.stringify(json.object));

                    if(json.object.language === "N"){navigate("Portaal");}
                    else if(json.object.language === "F"){navigate("Portail");}
                    else{navigate("Portal");}
                    
                    window.localStorage.removeItem("login_username")
                }
                else {
                    window.location.replace(process.env.REACT_APP_PREFIX);
                }
            }
        )
        

        //Go to dashboard
    }

    useEffect(()=>{
        const queryParams = new URLSearchParams(window.location.search)
        const regcode = (queryParams.get("regcode"));
        const email = (queryParams.get("email"));
        setemail(email);
        setregistrationcode(regcode);

        const registrationCheckData = {
            "email": email,
            "registrationcode": regcode
        }
        handleRegistrationCheck(registrationCheckData);
    }, [])

    const handleRegistrationVerify = (data) =>{
        fetch(process.env.REACT_APP_SERVER_LINK+"registrationVerify", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then(
            res => res.json()
        ).then(
            json => {
                if(json.errorcode === 0){
                    
                    // Qastan.addLog({
                    //     "level":Qastan.level.Info,
                    //     "type":Qastan.type.User_action,
                    //     "details": {
                    //         "title": "User registration",
                    //         "description": "User registrated successfully",
                    //         "eventtype": "onregister",
                    //     }
                    // })

                    localforage.clear();
                    window.localStorage.clear();
                    window.sessionStorage.clear();
                    handleLogin();
                }
            }
        )
    }

    const handleClickCompleteRegister = () =>{
        if(email !== "" && firstname !== "" && lastname !== "" && language !== "" && password !== ""){
            setshowRegistrationForm(false);

            const registrationVerifyData = {
                "email": email,
                "registrationcode": registrationcode,
                "firstname": firstname,
                "lastname": lastname,
                "password": password,
                "language": language
            }
            handleRegistrationVerify(registrationVerifyData)
        }
        else{
            if(firstname === ""){
                seterror_firstname(true);
            }

            if(lastname === ""){
                seterror_lastname(true);
            }

            if(pw1 === ""){
                seterror_pw1(true);
            }

            if(pw2 === ""){
                seterror_pw2(true);
            }

            if((pw1 !== pw2) && (pw1 !== "" && pw2 !== "")){
                seterror_pw1(true);
                seterror_pw2(true);
            }

            // Qastan.addLog({
            //     "level":Qastan.level.Warning,
            //     "type":Qastan.type.User_action,
            //     "details": {
            //         "title": "Registration not complete",
            //         "description": "User didn't fill in the form correct",
            //         "eventtype": "onregister",
            //     }
            // })
        }
    }

    const checkPassword = (id, e) =>{
        let tmp_v = e.currentTarget.value;
        if(id === 1){
            setpw1(tmp_v)

            if(tmp_v === pw2){
                setpassword(tmp_v);
                password_main = tmp_v;
            }
            else{
                setpassword('');
            }
        }
        if(id === 2){
            setpw2(tmp_v)

            if(tmp_v === pw1){
                setpassword(tmp_v);
                password_main = tmp_v;
            }
            else{
                setpassword('');
            }
        }
    }

    const [defaultValueFirstname, setdefaultValueFirstname] = useState("");
    const [defaultValueLastname, setdefaultValueLastname] = useState("");
    const [defaultValueLanguage, setdefaultValueLanguage] = useState("N");

    const handleRegistrationCheck = (registrationCheckData) =>{
        fetch(process.env.REACT_APP_SERVER_LINK+"registrationCheck", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(registrationCheckData)
        }).then(
            res => res.json()
        ).then(
            data => {
                if(data.errorcode === 0){
                    if(data.object.registration.firstname !== ""){setfirstname(data.object.registration.firstname); setdefaultValueFirstname(data.object.registration.firstname)}
                    if(data.object.registration.lastname !== ""){setlastname(data.object.registration.lastname); setdefaultValueLastname(data.object.registration.lastname)}
                    if(data.object.registration.language !== ""){setdefaultValueLanguage(data.object.registration.language)}
                    setwhite_overlay(true);
                    setTimeout(function(){
                        setwhite_overlay(false);
                        setwhite_overlayLR(true);
                        setshowRegistrationForm(true)
                        formLoaded(true);
                    }, 300)         
                }
                else{
                    seterrorTitle("Error - " + data.errorcode)
                    seterrorMessage("Foutcode [" + data.errorcode + "] " + data.message)
                    seterror(data);
                    setwhite_overlay(true);
                    setTimeout(function(){
                        setwhite_overlayLR(true);
                        setwhite_overlay(false);
                        setshowError(true);
                    }, 300)
                    
                    onError(true);
                }
            }
        )
    }

    const refreshRegistrationForm = () =>{
        setwhite_overlay(false);
        setwhite_overlayLR(false);
        setwhite_overlay(true);
        setTimeout(function () {
            setwhite_overlay(false);
            setshowError(false);
            seterrorMessage(null);
            seterror(null);
            onError(false);
        }, 300)

        const queryParams = new URLSearchParams(window.location.search)
        const regcode = (queryParams.get("regcode"));
        const email = (queryParams.get("email"));
        setemail(email);
        setregistrationcode(regcode);

        const registrationCheckData = {
            "email": email,
            "registrationcode": regcode
        }

        handleRegistrationCheck(registrationCheckData);

    }

    const translateError = (error) =>{
        switch (error.errorcode) {
            case 400:
                //Leave no fields blank
                return content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].FormError && content_state[ReactSession.get("language")].FormError.error_blankfields ? content_state[ReactSession.get("language")].FormError.error_blankfields : "Please do not leave any data blank.") : "Please do not leave any data blank."
                break;
            case 401:
                //Registration code invalid
                return content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].FormError && content_state[ReactSession.get("language")].FormError.error_regcodeinvalid ? content_state[ReactSession.get("language")].FormError.error_regcodeinvalid : "The registration code is not correct.") : "The registration code is not correct."
                break;
            case 402:
                //User already verified
                return content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].FormError && content_state[ReactSession.get("language")].FormError.error_useralreadyverified ? content_state[ReactSession.get("language")].FormError.error_useralreadyverified : "This user has already been verified.") : "This user has already been verified."
                break;
            default:
                return content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].FormError && content_state[ReactSession.get("language")].FormError.error_other ? content_state[ReactSession.get("language")].FormError.error_other : "Something unknown went wrong.") : "Something unknown went wrong."
                break;
        }

        return error.message;
    }

	return (

		<>
        <div className={styles.register_main}> 
        {(showRegistrationForm && !showError) ?
        <>
            {white_overlay && <div className={styles.white_overlayRL}></div>}
			{white_overlayLR && <div className={styles.white_overlayLR}></div>}
            <div>
                <h2>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Register.title ? content_state[ReactSession.get("language")].Register.title : "Register") : ""}</h2>
                {subtitle && <p className={styles.subtitle}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Register.subtitle ? content_state[ReactSession.get("language")].Register.subtitle : "") : ""}</p>}
                <Inputfield placeholder={content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Register.email_placeholder ? content_state[ReactSession.get("language")].Register.email_placeholder : "E-mail") : ""} type="email" value={email} disabled/>
                <div className={styles.inputFieldOneLine}>
                    <Inputfield defaultValue={defaultValueFirstname} placeholder={content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Register.firstname_placeholder ? content_state[ReactSession.get("language")].Register.firstname_placeholder : "First name") : ""} type="text" onChange={(e)=>{setfirstname(e.currentTarget.value); seterror_firstname(false)}} error={error_firstname}/>
                    <Inputfield defaultValue={defaultValueLastname} placeholder={content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Register.lastname_placeholder ? content_state[ReactSession.get("language")].Register.lastname_placeholder : "Last name") : ""} type="text" onChange={(e)=>{setlastname(e.currentTarget.value); seterror_lastname(false)}} error={error_lastname}/>
                </div>            
                <Dropdownlist 
                value={defaultValueLanguage}
                type="language" isSearchable={false} id="x" data={[
                        (content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.language_dutch && content_state[ReactSession.get("language")].General.language_dutch) : "Dutch"), 
                        (content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.language_french && content_state[ReactSession.get("language")].General.language_french) : "French"), 
                        (content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].General && content_state[ReactSession.get("language")].General.language_english && content_state[ReactSession.get("language")].General.language_english) : "English")
                    ]} placeholder={content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Register.language_placeholder ? content_state[ReactSession.get("language")].Register.language_placeholder : "Select a language") : ""} onChange={(v)=>setlanguage(v)} defaultValue theme="inputfield"/>
                <div className={styles.inputFieldOneLine}>
                    <Inputfield placeholder={content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Register.password_placeholder ? content_state[ReactSession.get("language")].Register.password_placeholder : "Password") : ""} type="password" onChange={(e)=>{checkPassword(1, e); seterror_pw1(false); seterror_pw2(false)}} error={error_pw1}/>
                    <Inputfield placeholder={content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Register.repeatpassword_placeholder ? content_state[ReactSession.get("language")].Register.repeatpassword_placeholder : "Repeat password") : ""} type="password" onChange={(e)=>{checkPassword(2, e); seterror_pw2(false); seterror_pw1(false)}} error={error_pw2}/>
                </div>    
                <div className={styles.registration_button}><Button value={content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Register.completeregistration_button ? content_state[ReactSession.get("language")].Register.completeregistration_button : "Complete registration") : ""} onClick={()=>handleClickCompleteRegister()}/></div>
            </div>
            
        </>
            :
            (showError ? 
            <>
            {white_overlay && <div className={styles.white_overlayRL}></div>}
			{white_overlayLR && <div className={styles.white_overlayLR}></div>}
            <div>
                <h2>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Register.error_title ? content_state[ReactSession.get("language")].Register.error_title : "Something went wrong") : ""}</h2>
                {subtitle && <p style={{fontWeight:"600", margin:"1rem 0 2rem 0"}}>{translateError(error)}</p>}
                <p className={styles.contact_message}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Register.error_contactmessage ? parse(content_state[ReactSession.get("language")].Register.error_contactmessage) : parse("<p>Please <span><a className={styles.linkTag} href='#'>contact</a></span> us if these error(s) persist</p>")) : ""}</p>
                {/* <p>Gelieve <span><a className={styles.linkTag} href="#">contact</a></span> met ons op te nemen indien deze fout(en) zich blijven voordoen</p> */}
                <div className={styles.registration_button}><Button value={content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Register.error_button ? content_state[ReactSession.get("language")].Register.error_button : "Try again") : ""} onClick={()=>{refreshRegistrationForm()}}/></div>
            </div>
            </>
            :
            <>
            {white_overlay && <div className={styles.white_overlayRL}></div>}
			{white_overlayLR && <div className={styles.white_overlayLR}></div>}
            <div style={{display:"flex", justifyContent:"center"}}>
                <FormLoader/>
            </div>
            </>
            )
        }      
        </div>
		</>
  	);
}